const REACT_APP_MAPBOX_API_KEY = process.env.REACT_APP_MAPBOX_API_KEY;

export const MAPBOX_CONFIG = {
  API_KEY: REACT_APP_MAPBOX_API_KEY,
  GEOCODING_URL: "https://api.mapbox.com/geocoding/v5/mapbox.places",
  COUNTRIES: "us,in",
  LANGUAGE: "en",
  LIMIT: 5,
  TYPES: "place",
  AUTOCOMPLETE: true,
};